import angular from 'angular';
import { dynamicSort, dynamicSortMultiple } from '@/shared/utils/dynamicSort';
import guid from '@/shared/utils/guid';

angular.module('cloudX').directive('cxTaskTemplatePicker', [
  '$filter',
  '$rootScope',
  '$http',
  'appUrls',
  '$q',
  function($filter, $rootScope, $http, appUrls, $q) {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      template: `<div>
        <tags-input
          ng-model="selected"
          placeholder="{{('Task template'|translate)}}"
          display-property="label"
          key-property="id"
          on-tag-added="updateValue()"
          on-tag-removed="updateValue()"
          replace-spaces-with-dashes="false"
          add-from-autocomplete-only="true"
          min-length="1"
          class="bootstrap">
          <auto-complete
            source="loadTemplates($query)"
            load-on-focus="true"
            load-on-empty="true"
            display-property="label"
            max-results-to-show="999"
            min-length="0"></auto-complete>
        </tags-input>
      </div>`,
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;
        $scope.selected = [];
        $scope.options = null;
        var findOption = function(code) {
          if (code == null || $scope.options.length === 0) return null;
          return $scope.options.find(function(el) {
            return el.id === code;
          });
        };
        var mapOptions = function() {
          if (!$scope.options) return;
          $scope.options = $scope.options
            .map(x => ({
              ...x,
              label:
                x.itemType === 0
                  ? $filter('translate')('Tasks without template')
                  : $filter('translateList')(x.id, 'taskTemplate', x.name),
            }))
            .sort(dynamicSortMultiple('itemType', 'label'));
          if ($scope.selected.length) {
            $scope.selected = $scope.selected.map(x => findOption(x.id));
          }
        };
        $scope.loadTemplates = function(search) {
          if ($scope.options != null) return $filter('filter')($scope.options, search);

          return $http.get(`${appUrls.tasks}/api/tasktemplates`).then(({ data }) => {
            $scope.options = data.map(x => ({ ...x, itemType: 1 }));
            if (attrs.withoutTemplate === '' || attrs.withoutTemplate !== 'false') {
              $scope.options.push({
                id: guid.empty,
                label: $filter('translate')('Tasks without template'),
                itemType: 0,
              });
            }
            mapOptions();
            return $filter('filter')($scope.options, search);
          });
        };
        var deregistration = $rootScope.$on('$translateChangeSuccess', mapOptions);
        $scope.$on('$destroy', deregistration);

        $scope.updateValue = function() {
          ngModel.$setViewValue($scope.selected.map(x => x.id));
        };

        ngModel.$render = function() {
          var value = ngModel.$viewValue;
          if (value !== null && typeof value !== 'undefined' && angular.isArray(value)) {
            if ($scope.selected.length || value.length)
              $q.when($scope.loadTemplates()).then(function() {
                $scope.selected = value.map(x => findOption(x));
              });
          }
        };
      },
    };
  },
]);
